import React from "react";
import Images from "../../../media/images";
import { useForm } from "react-hook-form";
import api from "../../../api/api";
import { toast } from "react-toastify";

const CreatePayment = () => {
  const { register, handleSubmit } = useForm();

  const handleSub = (data) => {
    
    const image = data.image[0]

    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("payment_type", data.payment_type);
    formData.append("name", data.name);
    formData.append("branch_name", data.branch_name)
    // formData.append("image", image)
    formData.append("acholderName", data.acholderName);
    formData.append("acnumber", data.acnumber);
    formData.append("contact_number", data.contact_number);

    formData.append("image", image);

    api
      .post("/info/payment-details/", formData)
      .then(response=> {
        toast.success("Payment created successfully")

      }).catch(error=> {
        toast.error("Something went wrong")
      })
  };

  return (
    <div>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create Payment
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>

      <form className="px-10" onSubmit={handleSubmit(handleSub)}>
        <div className="grid md:grid-cols-2  grid-cols-1 border-2 border-primary-blue font-bold mt-3">
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Title</label>
            <input
              type="text"
              name="title"
              placeholder="Title"
              {...register("title", { required: false })}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Payment Type</label>
            <br />
            <select
              className="text-primary-blue"
              {...register("payment_type", { required: false })}
            >
              <option>Select</option>
              <option value="BA">Bank</option>
              <option value="PH">Fone Pay</option>
              <option value="ES">E-sewa</option>
              <option value="OT">Other Details</option>
            </select>
          </div>
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Name</label>
            <br />
            <input
              type="text"
              className="text-primary-blue"
              placeholder="Name"
              {...register("name", { required: false })}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Branch Name</label>
            <br />
            <input
              type="text"
              className="text-primary-blue"
              placeholder="Branch Name"
              {...register("branch_name", { required: false })}
            ></input>
          </div>

          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Account Holder Name</label>
            <input
              type="text"
              placeholder="Company Name"
              className="text-primary-blue"
              name="acholderName"
              {...register("acholderName", { required: false })}

              //   {...register(
              //     "company_name",
              //     { required: false },
              //     // setValue("company_name", results?.company_name ?? "")
              //   )}
              //  defaultValue={results?.company_name ? results.company_name : ''}
            />
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Account Number</label>
            <input
              type="text"
              placeholder="Company Address"
              className="text-primary-blue"
              name="acnumber"
              {...register("acnumber", { required: false })}
            />
          </div>

          {/* <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Contact Number</label>
            <input
              type="text"
              placeholder="Contact Number"
              className="text-primary-blue"
              {...register("acnumber", {required:false})}
            />
          </div> */}

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Contact Number</label>
            <input
              type="text"
              placeholder="Contact Number"
              className="text-primary-blue"
              {...register("contact_number", { required: false })}
              //   defaultValue={
              //     results?.conatact_number ? results.conatact_number : ""
              //   }
            />
          </div>

          {/* <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Company PAN Number</label>
            <input
              type="text"
              placeholder="Company PAN Number"
              className="text-primary-blue"
            //   {...register("company_pan_vat", { required: false })}
            />
          </div> */}

          <div className="flex   p-3  border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Image</label>
            <input type="file" {...register("image", { required: false })} />
          </div>
        </div>

        <button
          type="submit"
          className=" bg-primary-blue text-white text-base p-2 rounded-2xl mt-3"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default CreatePayment;
